import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, MenuIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from '../ButtonLink';
import { ServicesMenu } from './ServicesMenu';
import { MobileMenu } from './MobileMenu';
import { useSiteHeader } from './useSiteHeader';
import { primaryNavLinks } from '../../data/navigation';
import { contact, images, urls } from '../../data/site';
export function SiteHeader() {
  const h = useSiteHeader();
  return <header className="sticky top-0 z-40 border-b border-line bg-paper" data-id="element-210" data-mp="luyjdwgs19g1">
      <div className="mx-auto flex h-[72px] max-w-[1320px] items-center justify-between gap-6 px-5 sm:px-8 lg:h-20 lg:px-12" data-id="element-211" data-mp="lx1hl3s328vu">
        <a href="#top" className="shrink-0" aria-label="Motor City Truck Collision, back to top" data-id="element-212" data-mp="uwes7zry13i5">
          <img src={images.logo} alt="Motor City Truck Collision" className="h-10 w-auto max-w-[190px] object-contain lg:h-12 lg:max-w-[240px]" data-id="element-213" data-mp="2sm69c8fu9cp8" />
        </a>

        <nav aria-label="Primary" className="hidden lg:block" data-id="element-214" data-mp="39kfgqueqxfy2">
          <ul className="flex items-center gap-1 xl:gap-3" data-id="element-215" data-mp="39lqiypsjmfn2">
            <li ref={h.servicesWrapRef} className="relative" onBlur={h.handleServicesBlur} data-id="element-216" data-mp="34sf9si09dmrz">
              <button ref={h.servicesButtonRef} type="button" aria-expanded={h.servicesOpen} aria-controls="services-menu" onClick={h.toggleServices} className={`inline-flex h-11 items-center gap-1.5 px-3 text-[15px] font-medium transition-colors duration-150 ease-out hover:text-brand-deep ${h.servicesOpen ? 'text-brand-deep' : 'text-ink'}`} data-id="element-217" data-mp="2zv5jl051p733">
                Services
                <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 transition-transform duration-200 ease-out ${h.servicesOpen ? 'rotate-180' : ''}`} data-id="element-218" data-mp="3dkz97kodjvdv" />
              </button>
              <AnimatePresence data-id="element-219" data-mp="228ontzbyn1jg">
                {h.servicesOpen && <ServicesMenu id="services-menu" onNavigate={h.closeServices} data-id="element-220" data-mp="u87yc2b8lx1p" />}
              </AnimatePresence>
            </li>
            {primaryNavLinks.map(link => <li key={link.href} data-id="element-221" data-mp="k98paimk7ze6">
                <a href={link.href} className="inline-flex h-11 items-center px-3 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:text-brand-deep" data-id="element-222" data-mp="k8795zqosmpl">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-223" data-mp="1i7mtkm8dlpv">
          <ButtonLink href={urls.quote} className="hidden h-11 px-5 text-[17px] sm:inline-flex md:h-11 md:px-5" data-id="element-224" data-mp="1jskvk7r7msh">
            Request a Quote
          </ButtonLink>
          <a href={contact.phoneHref} aria-label={`Call ${contact.phoneDisplay}`} className="inline-flex h-11 w-11 items-center justify-center border border-line text-ink lg:hidden" data-id="element-225" data-mp="3noxmz0sig41u">
            <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-226" data-mp="393ifp7ifk4u6" />
          </a>
          <button ref={h.mobileButtonRef} type="button" aria-expanded={h.mobileOpen} aria-controls="mobile-menu" aria-label="Open menu" onClick={h.openMobile} className="inline-flex h-11 w-11 items-center justify-center bg-ink text-paper lg:hidden" data-id="element-227" data-mp="351x6px90oap9">
            <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-228" data-mp="3rzi82jfblaea" />
          </button>
        </div>
      </div>

      <MobileMenu open={h.mobileOpen} onClose={h.closeMobile} onNavigate={h.navigateFromMobile} data-id="element-229" data-mp="3ny6r12aihxhp" />
    </header>;
}